import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconRedDot = createIcon({
  path: (
    <>
      <circle cx="12" cy="12" r="4" fill="red" />
    </>
  ),
});

export default IconRedDot;
